import React, { useState, useEffect } from 'react';
import './Transactions.scss';
import { useAuth } from '../../hooks/useAuth';
import { useHistory } from "react-router-dom";
import { Table } from 'react-bootstrap';
import i18n from '../../components/i18n';
import { useParams } from "react-router-dom";
import { useTransactions } from '../../hooks/useTransactions';
import { Formating } from '../../hooks/helper';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import * as Config from "../../config";

export const Transactions = () => {
    const auth = useAuth();
    let history = useHistory();
    const { type } = useParams();
    const trans = useTransactions();
    const [transactions, setTransactions] = useState([]);
    const subMenu = ['deposits', 'withdrawals', 'bonuses', 'credits'];
    const [swipeIcon, setSwipeIcon] = useState(localStorage.getItem('swipeIcon'))
    Config.SAVING && subMenu.push('saving');
    Config.STAKING && subMenu.push('staking');
    auth.checkLogin();
    
    useEffect(() => {
        let isCancelled = false;
        trans.getAll().then(data => {
            if (!isCancelled) {
                setTransactions(data.data);
            }
        });

        return () => {
            isCancelled = true;
        };
    }, [type])

    setTimeout(()=>{
        setSwipeIcon('false');
        localStorage.setItem('swipeIcon', 'false');
    },2000);

    if (!subMenu.includes(type)) {
        history.push('/transactions/deposits');
        return <></>;
    }


    const row = (item, i) => {
        i++;
        return (
            <tr key={i}>
                <td>{i}</td>
                <td>{Formating(item.amount, type === 'staking' ? '₿' : Config.CURRENCY_SYMBOL)}</td>
                <td>{item.transaction_type.name}</td>
                <td>{item.transaction_status.name}</td>
                <td>{item.transaction_id}</td>
                <td>{item.created_at}</td>
            </tr>
        )
    }

    const noData = () => {
        return <tr><td colSpan={6}>{i18n.t('transactions.no_data_to_show')}.</td></tr>;
    }

    const calculateTotal = (items) => {
        return items.reduce((acc, item) => {
            if(item.transaction_status_id === 1) {
                const raw = item?.amount ?? 0;
                const num = typeof raw === 'string' ? parseFloat(raw.replace(/,/g, '')) : Number(raw);
                return acc + (isNaN(num) ? 0 : num);
            }
            return acc;
        }, 0);
    }

    const depositStatus = [1,2,3,9,11];
    const bonusesStatus = [4,10];
    const creditsStatus = [5];
    const withdrawalsStatus = [6,7,8];
    const savingStatus = [12,13];
    const stakingStatus = [14,15];
    const deposits = transactions.filter(item => depositStatus.includes(item.transaction_type_id));
    const bonuses = transactions.filter(item => bonusesStatus.includes(item.transaction_type_id));
    const credits = transactions.filter(item => creditsStatus.includes(item.transaction_type_id));
    const withdrawals = transactions.filter(item => withdrawalsStatus.includes(item.transaction_type_id));
    const saving = transactions.filter(item => savingStatus.includes(item.transaction_type_id));
    const staking = transactions.filter(item => stakingStatus.includes(item.transaction_type_id));

    const savingBalance = calculateTotal(saving);
    const savingBalanceFormatted = Formating(savingBalance, Config.CURRENCY_SYMBOL);
    const stakingBalance = calculateTotal(staking);
    const stakingBalanceFormatted = Formating(stakingBalance, '₿');
    return (<>
        <div className="transactions sec-pad">
            {(type === 'saving' && auth.info.user.saving_interest != 0) &&
            <div className="saving-legend">
                <div className='brown short'>
                    <div className="wrapper">
                        <h5 className="title">Level {auth.info.user.level}</h5>
                    </div>
                    <div className='interest'><small>Interest</small>{auth.info.user.saving_interest}%</div>
                </div>
                <div className='blue short'>
                    <div className="wrapper">
                        <h5 className="title">Balance</h5>
                    </div>
                    <div className="interest"><small>Total</small>{savingBalanceFormatted}</div>
                </div>
            </div>
            }
            {(type === 'staking' && auth.info.user.staking_reward != 0) &&
            <div className="saving-legend">
                <div className='orange short'>
                    <div className="wrapper">
                        <h5 className="title">Level {auth.info.user.level}</h5>
                    </div>
                    <div className='interest'><small>Reward</small>{auth.info.user.staking_reward}%</div>
                </div>
                <div className='deep-blue short'>
                    <div className="wrapper">
                        <h5 className="title">Balance</h5>
                    </div>
                    <div className="interest"><small>Total</small>{stakingBalanceFormatted}</div>
                </div>
            </div>
            }
            <h1>{i18n.t('transactions.title')}</h1>
            <div className="tabs">
                {subMenu.map((item, i) => {
                    return <Link key={i} to={`/transactions/${item}`} className={type === item ? 'active' : ''}>{i18n.t(`transactions.${item}`)}</Link>
                })}
                {type === 'withdrawals' && <Link to="/payment/withdraw" className="float-right"><FontAwesomeIcon icon={faPlusCircle} /></Link>}
                {type === 'deposits' && <Link to="/payment/deposit" className="float-right"><FontAwesomeIcon icon={faPlusCircle} /></Link>}
            </div>
            <div className="wrapper-table">
                {swipeIcon !== 'false' && <div className="swipe-icon"><img src="/assets/img/icon-swipe.png" alt="" /></div>}
                <Table bordered hover responsive>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>{i18n.t('transactions.amount')}</th>
                            <th>{i18n.t('transactions.type')}</th>
                            <th>{i18n.t('transactions.status')}</th>
                            <th>{i18n.t('transactions.number')}</th>
                            <th>{i18n.t('transactions.time')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(type === 'deposits') && ((deposits.length > 0) ? deposits.map((item, i) => row(item, i)) : noData())}
                        {(type === 'bonuses') && ((bonuses.length > 0) ? bonuses.map((item, i) => row(item, i)) : noData())}
                        {(type === 'credits') && ((credits.length > 0) ? credits.map((item, i) => row(item, i)) : noData())}
                        {(type === 'withdrawals') && ((withdrawals.length > 0) ? withdrawals.map((item, i) => row(item, i)) : noData())}
                        {(type === 'saving') && (auth.info.user.saving_interest != 0
                            ? (saving.length > 0 ? saving.map((item, i) => row(item, i)) : noData())
                            : <tr><td colSpan={6} style={{ color: 'red' }}>To access the Savings, Please contact your account manager.</td></tr>
                        )}
                        {(type === 'staking') && (auth.info.user.staking_reward != 0
                            ? (staking.length > 0 ? staking.map((item, i) => row(item, i)) : noData())
                            : <tr><td colSpan={6} style={{ color: 'red' }}>To access the Staking, Please contact your account manager.</td></tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    </>);
}